import React, { useEffect, useState ,useRef} from "react";
import "./SmartCashPayment.scss";
import ToastMsg from "../../../shared/components/ToastMsg/ToastMsg";
import { useNavigate } from "react-router-dom";
import { useLoading } from "../../../../../Shared/cache/context/LoadingProvider";
import { eventEmitter } from "../../../../../Shared/service/google-analytics.service";
import { intiatePayment, processTrans, checkAMstatus } from "../../../shared/service";
import { useLanguage } from "../../../../../Shared/cache/context/LanguageProvider";
import useFetch from "../../../../../Shared/cache/useFetch";
import { TRANSLATION, GET, ORP_TRANSLATION } from "../../../../../Shared/helper/constants";
import { INTIATE_PAYMENT, PROCESS_TRXN } from "../../../helper/constants";

export default function MidSection() {
    const [mobileNumber, setMobileNumber] = useState("");
    const [toastMsg, setToastMsg] = useState(null);
    const [msisdnError, setMsisdnError] = useState("");
    const [txnInfo, setTxnInfo] = useState();
    const { showLoader, hideLoader } = useLoading();
    const [leadInfo, setLeadInfo] = useState({})
    const [showLoadingMsg, setShowLoadingMsg] = useState(false)
    const navigate = useNavigate();
    const { languagePrefix, selectedLanguage } = useLanguage();
    const [maxRetry, setMaxRetry] = useState(4);
    const [counter, setCounter] = useState(0);
    const [txnId, setTxnId] = useState("");
    const isFirstRender = useRef(true);

    const [translation, setTranslation] = useState({
        howWillYouPay: "How will you pay",
        cancel: "Cancel",
        proceed: "Proceed",
        am_push_message_note: "Note : Your transaction is in progress. Please do not press back button",
        mpesa_push_messages_start: "Hi, We have sent authentication request on this number.",
        mpesa_push_messages_end: "Please enter your SmartCash Pin on your mobile to proceed with the transaction.",
        paymentMethod:"Payment Method",
        processing:"Processing"
    })

    const { data: data, refetch } = useFetch({
        url: ORP_TRANSLATION.replace('languagePrefix', languagePrefix),
        method: GET,
        key: TRANSLATION,
        initialEnabled: false,
        cache: {
            enabled: true,
            ttl: 3600
        }
    });

    useEffect(() => {
        const cachedData = sessionStorage.getItem(`${TRANSLATION}_${selectedLanguage}`);
        if (!cachedData) {
            refetch(true);
        } else {
            refetch(false)
        }
    }, [selectedLanguage]);

    useEffect(() => {
        if (data?.payment.smartCashPayment) {
            setTranslation(data?.payment.smartCashPayment)
        }
    }, [data])

    useEffect(() => {
        let txnInfo = sessionStorage.getItem("queryData");
        txnInfo = JSON.parse(txnInfo);
        setTxnInfo({ ...txnInfo });
        let leadInformation = sessionStorage.getItem('airtelWorks');
        if (leadInformation) {
            leadInformation = JSON.parse(leadInformation || {})
            setLeadInfo(leadInformation);
        }
    }, [])

    useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return; 
        }
        let intervalStatusId;
        if (counter <= maxRetry) {
         intervalStatusId = setTimeout(() => callCheckStatus(txnId), 15000);
        }   
        return () => clearTimeout(intervalStatusId); 
      },[counter])

    const checkMsisdn = (val, event) => {
        if (val) {
            val = val.replace(/[^0-9]/g, "");
            event.target.value = val;
        }
    };

    const handleChange = (e) => {
        setMobileNumber(e.target.value)
        const { name, value } = e.target;
        if (name == "msisdn") {
            if (value.trim() === "") {
                setMsisdnError("Phone No is required");
            } else {
                setMsisdnError("");
            }
        }
    };
    const cancelTransaction = () => {
        navigate(txnInfo.redirectPage);
    };

  

    const initiateRecharge = (event) => {
        event.preventDefault();
        showLoader();
        let postRequestData = {
            paymentMobile: process.env.REACT_APP_OPCO.toLowerCase() == "ga" ? "0" + mobileNumber : mobileNumber,
            amount: txnInfo.amount,
            countryCode: process.env.REACT_APP_COUNTRY_CODE || "234",
            currencyCode: process.env.REACT_APP_CURRENCY,
            emailId: "",
            mobileNumber: txnInfo?.msisdn,
            productCode: txnInfo?.productCode || null,
            transactionType: leadInfo?.isAirtelWorks ? "HBB_LEADS" : txnInfo?.transactionType,
            unit: Number(txnInfo?.amount),
            loggedInNumber: (txnInfo?.invoiceDetail && txnInfo?.invoiceDetail?.accountNo) || null,
            accountId: (txnInfo?.invoiceDetail && txnInfo?.invoiceDetail?.accountNo) || null,
            invoiceNumber: (txnInfo?.invoiceDetail && txnInfo?.invoiceDetail?.invoiceNo) || null,
            paymentMode: "SMARTCASH",
            txnId: leadInfo.id || ""
        };
        let postRequest = {
            data: postRequestData,
            url:INTIATE_PAYMENT
        };

        intiatePayment(postRequest)
            .then((res) => {
                res = res?.data;
                hideLoader();
                if (
                    res &&
                    (res?.statusCode == 200 || res?.status?.toLowerCase() == "success")
                ) {
                    res?.result?.transactionId ? processRecharge(res?.result?.transactionId) : console.error("error txn id not found", res);
                    eventEmitter('ORP', 'Initiate SmartCash Payment Success', 'click', 'Initiate SmartCash Payment Success', null);
                } else {
                    console.log("error");
                    showToastMsg('Error', res?.message || "Something Went Wrong!")
                    eventEmitter('ORP', 'Initiate SmartCash Payment Failed', 'click', res?.statusCode?.toString() || res?.message, null);
                }
            })
            .catch((error) => {
                hideLoader();
                console.log(error);
                showToastMsg('Error', error?.error?.message || error?.message || "Something Went Wrong!")
            });
    };

    const showToastMsg = (type, message) => {
        setToastMsg({ type, message });
        setTimeout(() => setToastMsg(null), 10000);
    }

    const processRecharge = (txnId) => {
        let postRequestData = {
            paymentMobile: process.env.REACT_APP_OPCO.toLowerCase() == "ga" ? "0" + mobileNumber : mobileNumber,
            transactionId: txnId,
            isSubscriberRequest: true,
            paymentMode: "SMARTCASH",
            proccessFlag: true,
        };

        let postRequest = {
            data: postRequestData,
            url:  PROCESS_TRXN,
        };
        showLoader();
        processTrans(postRequest)
            .then((res) => {
                res = res?.data;
                hideLoader();
                if (
                    res &&
                    (res?.statusCode == 200 || res?.status?.toLowerCase() == "success")
                ) {
                    setShowLoadingMsg(true);
                    let transactionId = res?.result?.transactionId;
                    setTxnId(transactionId);
                    transactionId ? callCheckStatus(transactionId) : console.log("Transaction ID not found in the api response", res);
                    eventEmitter('ORP', 'Process SmartCash Payment Success', 'click', 'Process SmartCash Payment Success', null);
                } else {
                    showToastMsg('Error', res?.message || "Something Went Wrong!")
                    eventEmitter('ORP', 'Process SmartCash Payment Failed', 'click', res?.statusCode?.toString() || res?.message, null);
                }
            })
            .catch((error) => {
                console.log(error);
                hideLoader();
                showToastMsg('Error', error?.error?.message || error?.message || "Something Went Wrong!")
                eventEmitter('ORP', 'Process SmartCash Payment Failed', 'click', error?.error?.toString(), null);
            });
    };

    const callCheckStatus = (txnId) => {
        checkAMstatus(txnId).then(
            (res) => {
                res = res?.data;
                if (
                    res &&
                    (res?.statusCode == 200 || res?.status?.toLowerCase() == "success")
                ) {
                    if (res?.result && res?.result?.transactionStatus) {
                        if (
                            res?.result?.transactionStatus &&
                            res?.result?.transactionStatus == "IN_PROCESS" && counter <= maxRetry
                        ) {
                            // let intervalId = setTimeout(() => callCheckStatus(txnId), 15000);
                            setCounter(function (prevCount) {
                                return (prevCount += 1);
                              });
                            return;
                        } else {
                            setShowLoadingMsg(false)
                            if (res?.result?.transactionId) {
                                navigateToStatusPage(res?.result?.transactionId);
                            }
                        }
                        eventEmitter('ORP', 'SmartCash Payment Check Status Success', 'click', 'SmartCash Payment Check Status Success', null);
                    } else {
                    }
                } else {
                    showToastMsg('Error', res.message || "Something Went Wrong!")
                    eventEmitter('ORP', 'SmartCash Payment Check Status Failed', 'click', res?.message, null);

                }
            },
            (error) => {
                console.log(error);
                showToastMsg('Error', error?.error?.message || error?.message || "Something Went Wrong!")
                eventEmitter('ORP', 'SmartCash Payment Check Status Failed', 'click', error?.error?.toString(), null);

            }
        );
    };
    const navigateToStatusPage = (txnId) => {
        if (txnId) {
            navigate("/payment/status?id=" + txnId);
            return;
        }
    };
    return (
        <>
            <div className="card-pay-container ">
                <h3>{translation?.howWillYouPay}</h3>
                <div className="smartcash-pay">
                    <div className="payment-method">
                        <h5 >{translation?.paymentMethod}</h5>
                        <img
                            src="assets/icons/smartcash-logo.png"
                            width="200px" className="smartcash-logo"
                        />
                    </div>
                    <form autoComplete="off">
                        <div className="card-pay-footer airtime_payment_form">
                            <div className="card-pay-form">
                                <span className="country_code">
                                    +{process.env.REACT_APP_COUNTRY_CODE}
                                </span>
                                <input
                                    type="text"
                                    name="msisdn"
                                    placeholder="Registered Mobile Number"
                                    value={mobileNumber}
                                    onChange={handleChange}
                                    onInput={(event) => checkMsisdn(event.target.value, event)}
                                    maxLength={process.env.REACT_APP_NUMBER_MAX_LENGTH}
                                    readOnly={showLoadingMsg}
                                />
                                {msisdnError && <p className="error">{msisdnError}</p>}
                            </div>
                        </div>
                        <div className="card-pay-payment-button">
                            <button
                                className="continue-btn"
                                disabled={msisdnError || mobileNumber.length != process.env.REACT_APP_NUMBER_MAX_LENGTH || showLoadingMsg}
                                onClick={(event) => initiateRecharge(event)}
                            >
                                {translation?.proceed}
                            </button>
                            <button onClick={cancelTransaction} className="cancel-btn" disabled={showLoadingMsg}>
                                {translation?.cancel}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            {showLoadingMsg && <div className="am-loader-container">
                <div class="processing">
                    {translation.processing}
                    <div class="dots">
                        <div class="dot"></div>
                        <div class="dot"></div>
                        <div class="dot"></div>
                    </div>
                </div>
                <p> {translation.mpesa_push_messages_start} ({mobileNumber}). {translation.mpesa_push_messages_end}
                    <span>
                        {translation.am_push_message_note}
                    </span></p >
            </div >
            }
            {toastMsg && <ToastMsg message={toastMsg.message} type={toastMsg.type} onClose={() => setToastMsg(null)}></ToastMsg>
            }
        </>
    );
}